import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { TransformWrapper, TransformComponent, useControls } from "react-zoom-pan-pinch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight, faMagnifyingGlassPlus, faMagnifyingGlassMinus, faArrowsRotate } from "@fortawesome/free-solid-svg-icons";
import HTTP from "../../../config/axios";
import { getOriginalUrlFromThumb } from "../../../config/utils/helper";

const Controls = () => {
    const { zoomIn, zoomOut, resetTransform, instance } = useControls();

    useEffect(() => {
        const wrapper = instance.wrapperComponent;
        if (!wrapper) return;
        const onWheel = (e: WheelEvent) => {
            e.preventDefault();
            e.deltaY < 0 ? zoomIn(0.5) : zoomOut(0.5);
        };
        wrapper.addEventListener("wheel", onWheel, { passive: false });
        return () => wrapper.removeEventListener("wheel", onWheel);
    }, [instance.wrapperComponent]);
    return (
        <div style={{
            position: "absolute", bottom: 40, left: "50%", transform: "translateX(-50%)",
            zIndex: 10, display: "flex", alignItems: "center", gap: "4px",
            background: "rgba(0,0,0,0.6)", borderRadius: "8px", padding: "6px 10px"
        }}>
            <button onClick={() => zoomIn()} title="Zoom in" style={btnStyle}>
                <FontAwesomeIcon icon={faMagnifyingGlassPlus} />
            </button>
            <button onClick={() => resetTransform()} title="Reset" style={btnStyle}>
                <FontAwesomeIcon icon={faArrowsRotate} />
            </button>
            <button onClick={() => zoomOut()} title="Zoom out" style={btnStyle}>
                <FontAwesomeIcon icon={faMagnifyingGlassMinus} />
            </button>
        </div>
    );
};

const btnStyle: React.CSSProperties = {
    background: "none",
    border: "1px solid rgba(255,255,255,0.3)",
    color: "#fff",
    borderRadius: "6px",
    padding: "6px 10px",
    cursor: "pointer",
    fontSize: "14px",
    lineHeight: 1,
};

const ImageViewer: React.FC = () => {
    const [searchParams] = useSearchParams();
    const vehicleId = searchParams.get("vehicleId");
    const startIndex = parseInt(searchParams.get("index") || "0", 10);

    const [images, setImages] = useState<any[]>([]);
    const [currentIndex, setCurrentIndex] = useState(startIndex);
    const cloudfrontURL = process.env.REACT_APP_CLOUDFRONT_URL || "";

    useEffect(() => {
        if (!vehicleId) return;
        HTTP.get(`/api/vehicle/thumbnail-images/${vehicleId}`).then((res) => {
            const { data: { status, data } } = res;
            if (status === 1) setImages(data);
        });
    }, [vehicleId]);

    useEffect(() => {
        setCurrentIndex(startIndex);
    }, [startIndex]);

    const currentImage = images[currentIndex]  
                            ? getOriginalUrlFromThumb(`${cloudfrontURL}${images[currentIndex].imageUrl}`)
                            : "";

    const handlePrev = () => setCurrentIndex((i) => (i > 0 ? i - 1 : images.length - 1));
    const handleNext = () => setCurrentIndex((i) => (i < images.length - 1 ? i + 1 : 0));

    return (
        <div style={{ height: "100vh", width: "100vw", backgroundColor: "#111", display: "flex", flexDirection: "column", overflow: "hidden" }}>
            <div style={{ flex: 1, position: "relative", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden" }}>

                <button onClick={handlePrev} style={{ position: "absolute", left: 0, top: 0, bottom: 0, zIndex: 10, background: "rgba(0,0,0,0.4)", border: "none", color: "#fff", padding: "0 18px", cursor: "pointer" }}>
                    <FontAwesomeIcon icon={faChevronLeft} size="2x" />
                </button>

                {currentImage && (
                    <TransformWrapper
                        key={currentIndex}
                        initialScale={1}
                        minScale={0.5}
                        maxScale={5}
                        wheel={{ disabled: true }}
                        pinch={{ step: 5 }}
                        doubleClick={{ mode: "zoomIn", step: 0.5 }}
                        centerOnInit
                    >
                        <TransformComponent
                            wrapperStyle={{ width: "100%", height: "100%", position: "absolute", top: 0, left: 0, cursor: 'pointer' }}
                            wrapperProps={{ title: "Click and drag to inspect image" }}
                        >
                            <img
                                src={currentImage}
                                style={{ maxWidth: "calc(100vw - 120px)", maxHeight: "calc(100vh - 80px)", objectFit: "contain", userSelect: "none", display: "block" }}
                            />
                        </TransformComponent>
                        <Controls />
                    </TransformWrapper>
                )}

                <button onClick={handleNext} style={{ position: "absolute", right: 0, top: 0, bottom: 0, zIndex: 10, background: "rgba(0,0,0,0.4)", border: "none", color: "#fff", padding: "0 18px", cursor: "pointer" }}>
                    <FontAwesomeIcon icon={faChevronRight} size="2x" />
                </button>
            </div>
        </div>
    );
};

export default ImageViewer;
